import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* ヘッダー - PC版固定 */}
      <div className="hidden md:block fixed top-0 left-0 right-0 z-50">
        <Header />
      </div>
      
      {/* メインコンテンツ */}
      <main className="flex-grow pb-24 md:pb-0">
        {children}
      </main>
      
      {/* フッター - スマホ版固定 */}
      <div className="md:relative fixed bottom-0 left-0 right-0 z-40">
        <Footer />
      </div>
    </div>
  );
};

export default Layout;